import React, { FunctionComponent, useMemo } from "react";
import {
  Attendance,
  InterventionGroup,
} from "../../../../../../../../../store/onboarding/cases/types";
import Table from "react-bootstrap/Table";
import moment from "moment";
import { getFullName } from "../../../../../../../../../utils/NamesUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faExclamationTriangle, faPen, faTimesCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { deleteAttendance } from "../../../../../../../../../store/onboarding/cases/actions";
import { showConfirmDialog } from "../../../../../../../../../store/confirm-dialog/actions";
import { Student } from "../../../../../../../../../store/onboarding/types";
import { ApplicationState } from "../../../../../../../../../store";
import useInterventionGroupAccess from "../../../../../../../../../utils/hooks/useInterventionGroupAccess";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type OwnProps = {
  group: InterventionGroup;
  attendances: Attendance[];
  onEdit: (attendance: Attendance) => void;
  isStudentDetail?:boolean;
  isGroupDetail?: boolean;
};

type Props = OwnProps;

const AttendanceTable: FunctionComponent<Props> = (props) => {
  const { group, attendances, onEdit, isStudentDetail, isGroupDetail } = props;

  const dispatch = useDispatch();

  const { isIntGrpIDsWithReadAccess } = useInterventionGroupAccess(group?.id);

  const onRemove = (attendanceId: number) => {
    if (group.id && attendanceId) {
      dispatch(deleteAttendance(group.id, attendanceId));
    }
  };

  const handleDelete = (attendanceId: number) => () => {
    dispatch(
      showConfirmDialog({
        onConfirm: () => onRemove(attendanceId),
        title: "Delete Attendance",
        text: (
          <>
            <p className="font-weight-bold"> Are you sure you want to delete this attendance record?</p>
            <p className="text-center">
              <FontAwesomeIcon 
                icon={faExclamationTriangle}
                style={{color:'red'}}
              /> {" "}
              <i>This action cannot be undone.</i>
            </p>
          </>
        ),
        confirmButtonText: "DELETE",
        centered: true,
      })
    );
  };

  let allStudent: Student[] = useMemo(() => {
    return group.student_goals.map((goal) => goal.student);
  },[group.student_goals]);


  return (
    <Table className="goalTable mb-0" bordered>
      <thead>
        <tr>
          <th>Date</th>
          <th>Present</th>
          <th>Absent</th>
          <th>Intervention(s)</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {attendances.map((attendance) => (
          <tr key={`attendance_${attendance.id}`}>
            <td>{moment(attendance.date).format("MM/DD/YYYY")}</td>
            <td>
              {attendance.present_students
                .map((ps) => getFullName(allStudent.find((s) => s.id === ps)))
                .join(", ") || 'N/A'}
            </td>
            <td>
              {attendance.absent_students
                .map((as) => getFullName(allStudent.find((s) => s.id === as)))
                .join(", ") || 'N/A'}
            </td>
            <td>
              {attendance.interventions
                .map(
                  (intId) => {
                    let groupIntName =  group.interventions.find((int) => int.id === intId)?.name
                    if(groupIntName) {
                      return groupIntName;
                    } else {
                      return group.archived_interventions.find((int) => int.id === intId)?.name
                    }
                  }
                )
                .join(", ")}
            </td>
            <td>
              {!isStudentDetail && !isGroupDetail && !isIntGrpIDsWithReadAccess &&
                <div className="intervention-entry-actions d-flex justify-content-center align-items-center">
                  <span className="edit">
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={
                        <Tooltip className="customTooltip" id= "tooltip-top">
                          Edit
                        </Tooltip>
                      }
                    >
                        <FontAwesomeIcon
                          icon={faPen}
                          onClick={() => onEdit(attendance)}
                        />
                    </OverlayTrigger>
                  </span>
                  
                  
                  
                  <span className="delete">
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={
                        <Tooltip className="customTooltip" id= "tooltip-top">
                          Delete
                        </Tooltip>
                      }
                    >
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          size="1x"
                          className="pointer"
                          style={{color:'red'}}
                          onClick={handleDelete(attendance.id)}
                        />
                    </OverlayTrigger>
                    
                  </span>
                </div>
              }
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default AttendanceTable;
